import { render, staticRenderFns } from "./PhasesDistributionView.vue?vue&type=template&id=f36e6ffa&scoped=true"
import script from "./PhasesDistributionView.vue?vue&type=script&lang=ts"
export * from "./PhasesDistributionView.vue?vue&type=script&lang=ts"
import style0 from "./PhasesDistributionView.vue?vue&type=style&index=0&id=f36e6ffa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f36e6ffa",
  null
  
)

export default component.exports